// import React from "react";
import NavHeader from "./inc/NavBar";
import Whyus from "./components/Whyus";
import Whyusbg from "./components/Whyusbg";
import Statistik from "./components/Statistik";
import Harga from "./components/Harga";
import Aturan from "./components/Aturan";
import Testimonial from "./components/Testimonial";
import Bali from "./components/Bali";
import Map from "./components/Map";
import Promo from "./components/Promo";
import Footer from "./inc/Footer";
import { BrowserRouter as Router} from "react-router-dom";
import CircularProgressWithLabel from "./functions/LoadingSpin";
import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Photo from "./components/Photo";


const App = () => {
  const [isFetching, setIsFetching] = useState(true);

  useEffect(() => {
    setTimeout(function () {
      console.log("Delayed for 5 second.");
      setIsFetching(false);
    }, 1000);
  }, []);

  if (isFetching) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center" ,margin:"25%"}}>
        <CircularProgressWithLabel/>
      </Box>
    );
  }
 
  return (

   <Router>
   
        <NavHeader/>
        <Statistik/>
        <Promo/>
        <Photo />
        <Whyus/>
        <Map/>
        <Harga/>
        <Aturan/>
        <Whyusbg/>
        <Testimonial/>
        <Bali/>
        <Footer/>
       
    
   </Router>
  );
}

export default App;
